import React, { useContext, useEffect, useState } from 'react'
import { FestivalIdolBookingPackageList } from '../../ApiServices/GanapatiVisarjan/GanapatiVisarjanApi';
import { LoaderContext } from '../../AuthContext/AuthContext';
import VisarjanFormModal from './VisarjanFormModal';
import LoginPopUp from '../../Components/LoginPopup';

const VisarjanSeva = () => {
    const userID = localStorage.getItem("userID");
    const { setLoader } = useContext(LoaderContext);
    const [packageList, setPackageList] = useState([])
    const [selectedPackage, setSelectedPackage] = useState([1]);
    const [ShowFormModal, setShowFormModal] = useState(false)
    const [loginPopUp, setLoginPopUp] = useState(null);

    const totalAmount = packageList
        .filter((seva) => selectedPackage.includes(seva.FIB_ServiceID))
        .reduce((sum, seva) => sum + seva.Price, 0);

    const [modelRequestData, setModelRequestData] = useState({
        Action: null,
    })
    useEffect(() => {
        FestivalIdolBookingPackageListData()
    }, [])

    const FestivalIdolBookingPackageListData = async () => {

        setLoader(true);
        try {
            const response = await FestivalIdolBookingPackageList();

            if (response?.ResponseCode === '0') {
                setLoader(false);
                const list = response?.DATA || [];
                setPackageList(list)
                const defaultServices = list
                    .filter((seva) => seva.IsDefaultService === true)
                    .map((seva) => seva.FIB_ServiceID);

                setSelectedPackage(defaultServices);
            }

        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    const handleCheckboxChange = (seva) => {
        if (seva.FIB_ServiceID === 1) return;
        if (selectedPackage.includes(seva.FIB_ServiceID)) {
            setSelectedPackage(selectedPackage.filter((FIB_ServiceID) => FIB_ServiceID !== seva.FIB_ServiceID));
        } else {
            setSelectedPackage([...selectedPackage, seva.FIB_ServiceID]);
        }
    };

    const HandleBookClicked = () => {
        if (userID === null || userID === undefined || userID === "") {
            setLoginPopUp(true)
        } else {
            setShowFormModal(true)
        }

    }



    return (
        <>
            <div className=" my-4">
                <h3 className="fw-bold mb-3">Select Visarjan Sevas</h3>
                <div className="list-group">
                    {packageList.map((seva) => (
                        <label
                            key={seva.FIB_ServiceID}
                            className="list-group-item d-flex justify-content-between align-items-center"
                        >
                            <div>
                                <input
                                    type="checkbox"
                                    className="form-check-input me-2"
                                    checked={selectedPackage.includes(seva.FIB_ServiceID)}
                                    onChange={() => handleCheckboxChange(seva)}
                                    disabled={seva.IsDefaultService}
                                />
                                {seva.ServiceName}
                            </div>
                            <span className="fw-bold text-success">₹{seva.Price}</span>
                        </label>
                    ))}
                </div>

                {/* Total */}
                <div className="mt-3 p-3 border rounded bg-light">
                    <h5 className="mb-0">
                        Total Amount: <span className="text-danger">₹{totalAmount}</span>
                    </h5>
                </div>

                <div className="d-flex justify-content-center">
                    <button
                        className=" Normal-app-btn "
                        onClick={() => HandleBookClicked()}
                    >
                        Proceed to Book
                    </button>
                </div>
            </div>
            <VisarjanFormModal show={ShowFormModal} onHide={() => setShowFormModal(false)} selectedPackage={selectedPackage} totalAmount={totalAmount} />
            {loginPopUp && (
                <LoginPopUp show={loginPopUp} onHide={() => setLoginPopUp(false)} />
            )}
        </>
    )
}

export default VisarjanSeva
